export const professionOptions = [
  {
    label: 'Angestellte:r oder Beamter/Beamtin in Vollzeit',
    value: 'EMPLOYED_FULLTIME',
  },
  {
    label: 'Angestellte:r oder Beamter/Beamtin in Teilzeit',
    value: 'EMPLOYED_PART_TIME',
  },
  {
    label: 'Geschäftsinhaber:in',
    value: 'BUSINESS_OWNER',
  },
  {
    label: 'Selbstständig',
    value: 'SELF_EMPLOYED_OR_FUNDED',
  },
  {
    label: 'In Ruhestand',
    value: 'RETIRED',
  },
  {
    label: 'Student:in',
    value: 'STUDENT',
  },
  {
    label: 'Hausfrau/ -mann',
    value: 'HOME_DUTIES',
  },
  {
    label: 'Erwerbslos',
    value: 'UNEMPLOYED',
  },
  {
    label: 'Unabhängiges Einkommen',
    value: 'INDEPENDENT_INCOME',
  },
];

export const industryOptions = [
  {
    label: 'Baugewerbe & Ingenieurwesen',
    value: 'CONSTRUCTION',
  },
  {
    label: 'Bildungswesen',
    value: 'EDUCATION',
  },
  {
    label: 'Finanzwesen, Versicherung, Bankwesen',
    value: 'FINANCE_AND_BANKING',
  },
  {
    label: 'Freizeit, Sport und Unterhaltung',
    value: 'ARTS_AND_ENTERTAINMENT_AND_RECREATION',
  },
  {
    label: 'Gesundheitswesen',
    value: 'HEALTH_SERVICES',
  },
  {
    label: 'Gewerbliche Dienstleistungen',
    value: 'SERVICES',
  },
  {
    label: 'Groß- / Einzelhandel',
    value: 'WHOLESALE_OR_RETAIL',
  },
  {
    label: 'Immobilien',
    value: 'REAL_ESTATE',
  },
  {
    label:
      'Juwelier:in, Antiquitäten, Kunsthändler:in, Registrierte Diamantenhändler:in',
    value: 'JEWELRY_OR_ANTIQUE_OR_ART_OR_DIAMOND',
  },
  {
    label: 'Lebensmittel- und Getränkeindustrie',
    value: 'FOOD_SERVICES',
  },
  {
    label: 'Luft- und Raumfahrt, Verteidigung',
    value: 'AEROSPACE_OR_DEFENSE',
  },
  {
    label: 'Öffentlicher Dienst/Verwaltung',
    value: 'GOVERNMENT_OR_PUBLIC_SECTOR',
  },
  {
    label: 'Öl, Gas, Bergbau',
    value: 'MINING',
  },
  {
    label: 'Reisen, Tourismus und Gastgewerbe/ Casinos/ Glücksspiel',
    value: 'HOSPITALITY_OR_LODGING',
  },
  {
    label: 'Telekommunikation/IT',
    value: 'TELECOMMUNICATIONS',
  },
  {
    label: 'Transportwesen',
    value: 'TRANSPORTATION_UTILITIES',
  },
  {
    label: 'Sonstige',
    value: 'OTHER',
  },
];

export const occupationOptions = {
  CONSTRUCTION: [
    {
      label: 'Architekt:in/ Ingenieur:in',
      value: 'ARCHITECT_ENGINEER',
    },
    {
      label: 'Berater:in ',
      value: 'CONSULTANT',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Fachkraft',
      value: 'SKILLED_WORKER',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Hilfsarbeiter:in',
      value: 'LABORER',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  EDUCATION: [
    {
      label: 'Berater:in',
      value: 'CONSULTANT',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Coach / persönliche/-r Berater:in',
      value: 'COACH_COUNSELLOR',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Lehrer:in',
      value: 'TEACHER',
    },
    {
      label: 'Professor:in',
      value: 'PROFESSOR',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  FINANCE_AND_BANKING: [
    {
      label: 'Analyst:in',
      value: 'ANALYST',
    },
    {
      label: 'Berater:in',
      value: 'CONSULTANT',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Finanzberater:in/ Versicherungsvertreter:in/ Finanzagent:in',
      value: 'FINANCIAL_ADVISOR',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Investmentbanker:in',
      value: 'INVESTMENT_BANKER',
    },
    {
      label: 'Kundenbetreuer:in',
      value: 'CUSTOMER_SERVICE',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  ARTS_AND_ENTERTAINMENT_AND_RECREATION: [
    {
      label: 'Berater:in',
      value: 'CONSULTANT',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Kundenbetreuer:in',
      value: 'CUSTOMER_SERVICE',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Vertreter:in /Makler:in',
      value: 'AGENT_BROKER',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  HEALTH_SERVICES: [
    {
      label: 'Apotheker:in',
      value: 'PHARMACIST',
    },
    {
      label: 'Arzt/Ärztin, Zahnarzt/ -ärztin',
      value: 'DOCTOR_DENTIST',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Büroangestellte / -r',
      value: 'OFFICE_STAFF',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Krankenpfleger:in / Therapeut:in',
      value: 'NURSE_THERAPIST',
    },
    {
      label: 'Pharmavertreter:in',
      value: 'PHARMACEUTICAL_SALES',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  SERVICES: [
    {
      label: 'Berater:in',
      value: 'CONSULTANT',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Trader:in/Händler:in',
      value: 'TRADER_DEALER',
    },
    {
      label: 'Fachkraft',
      value: 'SKILLED_WORKER',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  WHOLESALE_OR_RETAIL: [
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Vertrieb',
      value: 'SALES',
    },
    {
      label: 'Vertriebshändler:in',
      value: 'DISTRIBUTOR',
    },
    {
      label: 'Einzelhandelsmithilfsarbeiter:in',
      value: 'RETAIL_STAFF',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  REAL_ESTATE: [
    {
      label: 'Berater:in',
      value: 'CONSULTANT',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Immobilienmakler:in/ Hypothekenmakler:in',
      value: 'REAL_ESTATE_AGENT_BROKER',
    },
    {
      label: 'Entwickler:in',
      value: 'DEVELOPER',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  JEWELRY_OR_ANTIQUE_OR_ART_OR_DIAMOND: [
    {
      label: 'Berater:in',
      value: 'CONSULTANT',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Trader:in/Händler:in',
      value: 'TRADER_DEALER',
    },
    {
      label: 'Fachkraft',
      value: 'SKILLED_WORKER',
    },
    {
      label: 'Diamantenhändler:in',
      value: 'DIAMOND_TRADER',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  FOOD_SERVICES: [
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Kraftfahrer:in / Fahrzeugführer:in',
      value: 'DRIVER',
    },
    {
      label: 'Service-Mitarbeiter:in',
      value: 'SERVICE_SALES_STAFF',
    },
    {
      label: 'Koch/Köchin',
      value: 'CHEF',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  AEROSPACE_OR_DEFENSE: [
    {
      label: 'Berater:in',
      value: 'CONSULTANT',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Architekt:in/ Ingenieur:in',
      value: 'ARCHITECT_ENGINEER',
    },
    {
      label: 'Fachkraft',
      value: 'SKILLED_WORKER',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  GOVERNMENT_OR_PUBLIC_SECTOR: [
    {
      label: 'Berater:in',
      value: 'CONSULTANT',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Politiker:in',
      value: 'POLITICIAN',
    },
    {
      label: 'Öffentlich Bedienstete',
      value: 'PUBLIC_SERVANT',
    },
    {
      label: 'Rettungsdienste',
      value: 'EMERGENCY_SERVICES',
    },
    {
      label: 'Militärische Dienste',
      value: 'SELF_DEFENSE_FORCE',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  MINING: [
    {
      label: 'Berater:in',
      value: 'CONSULTANT',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Architekt:in/ Ingenieur:in',
      value: 'ARCHITECT_ENGINEER',
    },
    {
      label: 'Hilfsarbeiter:in',
      value: 'LABORER',
    },
    {
      label: 'Fachkraft',
      value: 'SKILLED_WORKER',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  HOSPITALITY_OR_LODGING: [
    {
      label: 'Berater:in',
      value: 'CONSULTANT',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Service-Mitarbeiter:in',
      value: 'SERVICE_SALES_STAFF',
    },
    {
      label: 'Reiseberater:in',
      value: 'TRAVEL_AGENT',
    },
    {
      label: 'Kundenbetreuer:in',
      value: 'CUSTOMER_SERVICE',
    },
    {
      label: 'Casino/Glücksspiel-Management',
      value: 'CASINO_GAME_MANAGEMENT',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  TELECOMMUNICATIONS: [
    {
      label: 'Berater:in',
      value: 'CONSULTANT',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Software-Ingenieur:in',
      value: 'ENGINEER_TECHNOLOGY_DEVELOPMENT',
    },
    {
      label: 'Kundenbetreuer:in',
      value: 'CUSTOMER_SERVICE',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  TRANSPORTATION_UTILITIES: [
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Kraftfahrer:in / Fahrzeugführer:in',
      value: 'DRIVER',
    },
    {
      label: 'Vertrieb',
      value: 'SALES',
    },
    {
      label: 'Kundenbetreuer:in',
      value: 'CUSTOMER_SERVICE',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
  OTHER: [
    {
      label: 'Berater:in',
      value: 'CONSULTANT',
    },
    {
      label: 'Buchhalter:in',
      value: 'ACCOUNTANT',
    },
    {
      label: 'Rechtsanwalt / -anwältin',
      value: 'LAWYER',
    },
    {
      label: 'Wohltätigkeitsverwaltung',
      value: 'NONPROFIT_ORGANIZATION',
    },
    {
      label: 'Geschäftsleitung',
      value: 'EXECUTIVE',
    },
    {
      label: 'Direktor:in/ Manager:in/ Vorgesetzte/-r',
      value: 'DIRECTOR_MANAGER_SUPERVISOR',
    },
    {
      label: 'Sonstige',
      value: 'OTHER',
    },
  ],
};
